import { extend } from "vee-validate";
import { required, max, size, mimes } from "vee-validate/dist/rules";
extend("required", required);
extend("max", max);
extend("size", size);
extend("mimes", mimes);
